const newsList = function() {
  return new Promise((resolve, reject) =>
    this.request({
      method: "GET",
      url: "/news/getList"
    })
      .then(resolve)
      .catch(reject)
  );
};

export { newsList };
